export const SUCCESS = "SUCCESS";
export const FAILED = "FAILED";
export const PROCESSING = "PROCESSING"
export const IN_PROGRESS = "IN_PROGRESS"
export const CANCELED = "CANCELED"
export const EXPIRED = "EXPIRED"
export const CONFIRMED = "CONFIRMED"